// extracted by css-extract-rspack-plugin
export default {"content":"CYNw54UR8yIouE0d"};